<template>
    <div class="rewards-container">  
        <div class="block-page-title">
            <h2>Rewards</h2>
            <p>Welcome to our rewards programme</p>
        </div>
    </div>
    <div class="rewards-container-bg">  
        <div class="rewards-container">  
            <div class="block-rewards">
                <h3>Your rewards</h3>
                <div class="tab-rewards">
                    <span :class="{ 'active': viewTab }" @click="viewTab = !viewTab">Available</span>
                    <span :class="{ 'active': !viewTab }" @click="viewTab = !viewTab">Applied</span>
                </div>
                <div class="available-items"  v-if="viewTab">
                    <h4 v-if="availableListEmpty" class="empty-list">The list of available coupons is empty</h4>
                    <ul v-else>
                        <li v-for="(coupon, i ) in couponsAvailable" :key="i" :class="'type-' + coupon.type">
                            <cardCoupon :data="coupon" status="Available"/>
                        </li>
                    </ul>
                </div>
                <div class="available-items"  v-if="!viewTab">
                    <h4 v-if="appliedListEmpty" class="empty-list">The list of applied coupons is empty</h4>
                    <ul v-else>
                        <li v-for="(coupon, i ) in couponsApplied" :key="i" :class="'type-' + coupon.type">
                            <cardCoupon :data="coupon" status="Applied"/>
                        </li>
                    </ul>
                </div>
            </div>    
            <mainAccountContent :userDetails="userDetails" />
        </div>
        <loaderApp v-if="loader"></loaderApp>
        <alertApp />
    </div>
</template>

<script>

import mainAccountContent from '@/components/account/mainAccountContent.vue';
import cardCoupon from '@/components/cards/cardCoupon.vue';
import loaderApp from '@/components/common/loaderApp.vue';
import alertApp from '@/components/common/alertApp.vue';

export default {
    name: 'RewardsApp',
    components: {
        mainAccountContent,
        cardCoupon,
        loaderApp,
        alertApp
    },
    data() {
        return {
            viewTab: true,
            couponsApplied: [],
            couponsAvailable: [],
            availableListEmpty: false,
            appliedListEmpty: false,
        }
    },
    methods: {

    },
    computed: {
        loader() {
            return this.$store.getters.loader ?? false;
        },
        userDetails() {
            return this.$store.getters.userDetails;
        },
    },
    async beforeMount() {
        this.$store.dispatch('getUserDetails');
    },
    watch: {
        userDetails(newData) {
            if (newData.available_coupons && newData.available_coupons.length > 0) {              
                this.couponsAvailable = newData.available_coupons;
            } else {
                this.availableListEmpty = true;
            }

            if ( newData.applied_coupons && newData.applied_coupons.length > 0 ) {
                this.couponsApplied = newData.applied_coupons;
            } else {
                this.appliedListEmpty = true;
            }
        }
    }

}
</script >

<style lang="stylus">
@import 'vuetify/dist/vuetify.min.css';
@import url('https://fonts.googleapis.com/css2?family=Manrope:wght@400;700&display=swap');

* {
  box-sizing: border-box;
}

.v-btn--icon.v-btn--density-default,                     
.v-btn--elevated {
    box-shadow: none!important;
}

.v-ripple__container,
.v-field__outline,
.v-btn__overlay,
.v-field__overlay,
.v-btn__underlay {
  display: none!important;
}

.rewards-container {
  max-width: 1100px;
  margin: 0 auto;
}

.block-page-title {
    padding: 2rem 0;

    h2 {
        color: #1D2433;
        font-family: 'Manrope', sans-serif;
        font-size: 26px;
        font-style: normal;
        font-weight: 800;
        line-height: normal;
        margin-bottom: .5rem;
    }
    p {
        color: #1D2433;
        font-family: Manrope;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
}

.block-rewards {
    h3 {
        color: #1D2433;
        font-family: Manrope;
        font-size: 22px;
        font-style: normal;
        font-weight: 800;
        line-height: normal;
        margin-bottom: 1rem;
    }

    .tab-rewards {
        display: flex;
        align-items: center;

        span {
            padding: 0 1rem 0 0;
            position: relative;
            color: #1D2433;
            text-align: center;
            font-family: Manrope;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            cursor: pointer;
            transition-duration: 0.4s;

            &:hover {
                color: #685BC7;
            }
            &.active {
                color: #685BC7;

                &:after {
                    content: '';
                    position: absolute;
                    transition-duration: 0.4s;
                    width: calc(100% - 1rem);
                    height: 2px;
                    background: #685BC7;
                    left: 0;
                    bottom: -3px;
                }

                &:hover {
                    &:after {
                        width: 0;
                    }
                }
            }
        }
    }
}

.empty-list {
    margin-top: 2rem;
    margin-bottom: 5rem;
    font-weight: 400!important;
    font-size: 16px!important;
}
</style>